// import React from 'react';
// import SecondNav from "../Navbar/SecondNav";
// import TopNavbar from "../Navbar/TopNavbar";
// import ChatPopup from "./ChatPopup";
// import { Box, Typography, TextField, Button, MenuItem, Container, Grid, useTheme, useMediaQuery } from '@mui/material';
// import Footer from './Footer';
// import { motion } from 'framer-motion';

// function Booking() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   // Services list for dropdown
//   const services = [
//     'Armour Coating',
//     'Nano Armor Protection',
//     'Detailing',
//     'Window Tinting',
//   ];

//   // Animation variants for the form fields
//   const fieldVariants = {
//     hidden: { opacity: 0, y: 20 },
//     visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
//   };

//   return (
//     <div
//       className="home-page"
//       style={{
//         width: "100%",
//         minHeight: "100vh",
//         backgroundColor: "#f5f5f5",
//         position: "relative",
//       }}
//     >
//       <TopNavbar />
//       <SecondNav />

//       {/* Booking Section */}
//       <Box
//         sx={{
//           minHeight: '100vh',
//           backgroundImage: 'url(https://media.istockphoto.com/id/154945530/photo/convertible-going-through-car-wash.jpg?s=612x612&w=0&k=20&c=1jIwwRiFL_Et-qm0rv9TX3pguMeaX2Fjhy6pdi_eJ0o=)',
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           backgroundAttachment: 'fixed',
//           position: 'relative',
//           zIndex: 1,
//           '&::before': {
//             content: '""',
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.65))",
//             zIndex: -1,
//           },
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           py: 6,
//           mt: 4,
//         }}
//       >
//         {/* Hero Section */}
//         <Box sx={{ textAlign: 'center', mb: 6 }}>
//           <motion.div
//             initial={{ opacity: 0, scale: 0.9 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 1, ease: 'easeOut' }}
//           >
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 'bold',
//                 color: '#fff',
//                 textShadow: '0 4px 8px rgba(0,0,0,0.5)',
//                 fontSize: { xs: '2.5rem', md: '4rem' },
//                 background: 'linear-gradient(45deg, #1E88E5, #42A5F5)',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent',
//               }}
//             >
//               Book Your Service Now
//             </Typography>
//           </motion.div>
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8, delay: 0.3, ease: 'easeOut' }}
//           >
//             <Typography
//               variant="h6"
//               sx={{
//                 color: '#fff',
//                 fontSize: { xs: '1.2rem', md: '1.5rem' },
//                 fontWeight: 300,
//                 mt: 2,
//                 letterSpacing: '0.5px',
//               }}
//             >
//               Experience the Best in Automotive Care
//             </Typography>
//           </motion.div>
//         </Box>

//         {/* Booking Form */}
//         <Container maxWidth="md">
//           <motion.div
//             initial="hidden"
//             animate="visible"
//             variants={{
//               hidden: { opacity: 0 },
//               visible: { opacity: 1, transition: { staggerChildren: 0.2 } },
//             }}
//           >
//             <Box
//               sx={{
//                 backgroundColor: 'rgba(255, 255, 255, 0.1)', // Glassmorphism effect
//                 backdropFilter: 'blur(10px)',
//                 borderRadius: 8,
//                 boxShadow: '0 8px 30px rgba(0,0,0,0.3)',
//                 p: { xs: 3, sm: 5 },
//                 border: '1px solid rgba(255, 255, 255, 0.2)',
//                 maxWidth: 'sm', // Narrower form width to allow centering
//                 mx: 'auto', // Center the form container horizontally
//               }}
//             >
//               <Box
//                 component="form"
//                 sx={{
//                   display: 'flex',
//                   flexDirection: 'column',
//                   gap: 3,
//                   alignItems: 'center', // Center the form fields horizontally
//                 }}
//               >
//                 {/* Row 1: First Name and Second Name */}
//                 <Box sx={{ width: '100%' }}>
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} sm={6}>
//                       <motion.div variants={fieldVariants}>
//                         <TextField
//                           label="First Name"
//                           variant="outlined"
//                           fullWidth
//                           required
//                           sx={{
//                             '& .MuiOutlinedInput-root': {
//                               '& fieldset': { borderColor: '#1E88E5' },
//                               '&:hover fieldset': { borderColor: '#42A5F5' },
//                               '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
//                               backgroundColor: 'rgba(255, 255, 255, 0.05)',
//                             },
//                             '& .MuiInputLabel-root': { color: '#fff' },
//                             '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
//                             '& .MuiOutlinedInput-input': { color: '#fff' },
//                           }}
//                         />
//                       </motion.div>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <motion.div variants={fieldVariants}>
//                         <TextField
//                           label="Second Name"
//                           variant="outlined"
//                           fullWidth
//                           required
//                           sx={{
//                             '& .MuiOutlinedInput-root': {
//                               '& fieldset': { borderColor: '#1E88E5' },
//                               '&:hover fieldset': { borderColor: '#42A5F5' },
//                               '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
//                               backgroundColor: 'rgba(255, 255, 255, 0.05)',
//                             },
//                             '& .MuiInputLabel-root': { color: '#fff' },
//                             '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
//                             '& .MuiOutlinedInput-input': { color: '#fff' },
//                           }}
//                         />
//                       </motion.div>
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 {/* Row 2: Email and Phone Number */}
//                 <Box sx={{ width: '100%' }}>
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} sm={6}>
//                       <motion.div variants={fieldVariants}>
//                         <TextField
//                           label="Email"
//                           variant="outlined"
//                           fullWidth
//                           required
//                           type="email"
//                           sx={{
//                             '& .MuiOutlinedInput-root': {
//                               '& fieldset': { borderColor: '#1E88E5' },
//                               '&:hover fieldset': { borderColor: '#42A5F5' },
//                               '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
//                               backgroundColor: 'rgba(255, 255, 255, 0.05)',
//                             },
//                             '& .MuiInputLabel-root': { color: '#fff' },
//                             '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
//                             '& .MuiOutlinedInput-input': { color: '#fff' },
//                           }}
//                         />
//                       </motion.div>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <motion.div variants={fieldVariants}>
//                         <TextField
//                           label="Phone Number"
//                           variant="outlined"
//                           fullWidth
//                           required
//                           type="tel"
//                           sx={{
//                             '& .MuiOutlinedInput-root': {
//                               '& fieldset': { borderColor: '#1E88E5' },
//                               '&:hover fieldset': { borderColor: '#42A5F5' },
//                               '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
//                               backgroundColor: 'rgba(255, 255, 255, 0.05)',
//                             },
//                             '& .MuiInputLabel-root': { color: '#fff' },
//                             '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
//                             '& .MuiOutlinedInput-input': { color: '#fff' },
//                           }}
//                         />
//                       </motion.div>
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 {/* Row 3: Service, Preferred Date, Preferred Time */}
//                 <Box sx={{ width: '100%' }}>
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} sm={4}>
//                       <motion.div variants={fieldVariants}>
//                         <TextField
//                           select
//                           label="Service"
//                           variant="outlined"
//                           fullWidth
//                           required
//                           defaultValue=""
//                           sx={{
//                             '& .MuiOutlinedInput-root': {
//                               '& fieldset': { borderColor: '#1E88E5' },
//                               '&:hover fieldset': { borderColor: '#42A5F5' },
//                               '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
//                               backgroundColor: 'rgba(255, 255, 255, 0.05)',
//                             },
//                             '& .MuiInputLabel-root': { color: '#fff' },
//                             '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
//                             '& .MuiOutlinedInput-input': { color: '#fff' },
//                             '& .MuiSelect-icon': { color: '#fff' },
//                           }}
//                         >
//                           {services.map((service, index) => (
//                             <MenuItem key={index} value={service}>
//                               {service}
//                             </MenuItem>
//                           ))}
//                         </TextField>
//                       </motion.div>
//                     </Grid>
//                     <Grid item xs={12} sm={4}>
//                       <motion.div variants={fieldVariants}>
//                         <TextField
//                           label="Preferred Date"
//                           variant="outlined"
//                           fullWidth
//                           required
//                           type="date"
//                           InputLabelProps={{ shrink: true }}
//                           sx={{
//                             '& .MuiOutlinedInput-root': {
//                               '& fieldset': { borderColor: '#1E88E5' },
//                               '&:hover fieldset': { borderColor: '#42A5F5' },
//                               '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
//                               backgroundColor: 'rgba(255, 255, 255, 0.05)',
//                             },
//                             '& .MuiInputLabel-root': { color: '#fff' },
//                             '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
//                             '& .MuiOutlinedInput-input': { color: '#fff' },
//                           }}
//                         />
//                       </motion.div>
//                     </Grid>
//                     <Grid item xs={12} sm={4}>
//                       <motion.div variants={fieldVariants}>
//                         <TextField
//                           label="Preferred Time"
//                           variant="outlined"
//                           fullWidth
//                           required
//                           type="time"
//                           InputLabelProps={{ shrink: true }}
//                           sx={{
//                             '& .MuiOutlinedInput-root': {
//                               '& fieldset': { borderColor: '#1E88E5' },
//                               '&:hover fieldset': { borderColor: '#42A5F5' },
//                               '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
//                               backgroundColor: 'rgba(255, 255, 255, 0.05)',
//                             },
//                             '& .MuiInputLabel-root': { color: '#fff' },
//                             '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
//                             '& .MuiOutlinedInput-input': { color: '#fff' },
//                           }}
//                         />
//                       </motion.div>
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 {/* Row 4: Additional Notes */}
//                 <Box sx={{ width: '100%' }}>
//                   <motion.div variants={fieldVariants}>
//                     <TextField
//                       label="Additional Notes"
//                       variant="outlined"
//                       fullWidth
//                       multiline
//                       rows={3}
//                       sx={{
//                         '& .MuiOutlinedInput-root': {
//                           '& fieldset': { borderColor: '#1E88E5' },
//                           '&:hover fieldset': { borderColor: '#42A5F5' },
//                           '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
//                           backgroundColor: 'rgba(255, 255, 255, 0.05)',
//                         },
//                         '& .MuiInputLabel-root': { color: '#fff' },
//                         '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
//                         '& .MuiOutlinedInput-input': { color: '#fff' },
//                       }}
//                     />
//                   </motion.div>
//                 </Box>

//                 {/* Row 5: Book Now Button */}
//                 <Box sx={{ width: '100%' }}>
//                   <motion.div
//                     variants={fieldVariants}
//                     whileHover={{ scale: 1.02 }}
//                     whileTap={{ scale: 0.98 }}
//                   >
//                     <Button
//                       variant="contained"
//                       sx={{
//                         background: 'linear-gradient(45deg, #1E88E5, #42A5F5)', // Blue gradient
//                         color: '#fff', // White text
//                         fontWeight: '600',
//                         borderRadius: 3,
//                         padding: '12px 0',
//                         boxShadow: '0 4px 10px rgba(30, 136, 229, 0.4)',
//                         '&:hover': { 
//                           background: 'linear-gradient(45deg, #1565C0, #1E88E5)',
//                           boxShadow: '0 6px 15px rgba(30, 136, 229, 0.6)',
//                         },
//                       }}
//                       type="submit"
//                       fullWidth
//                     >
//                       Book Now
//                     </Button>
//                   </motion.div>
//                 </Box>
//               </Box>
//             </Box>
//           </motion.div>
//         </Container>
//       </Box>

//       <ChatPopup />
//       <Footer />
//     </div>
//   );
// }

// export default Booking;


import React, { useState, useEffect } from 'react';
import SecondNav from "../Navbar/SecondNav";
import TopNavbar from "../Navbar/TopNavbar";
import ChatPopup from "./ChatPopup";
import { Box, Typography, TextField, Button, MenuItem, Container, Grid, useTheme, useMediaQuery, Alert } from '@mui/material';
import Footer from './Footer';
import { motion } from 'framer-motion';

function Booking() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    firstName: '',
    secondName: '',
    email: '',
    phoneNumber: '',
    service: '',
    date: '',
    additionalNotes: '',
  });
  const [submissionStatus, setSubmissionStatus] = useState(null);

  // Fetch services from Firebase using REST API
  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://armour-pro-2a88a-default-rtdb.firebaseio.com/services.json');
        const data = await response.json();
        if (data) {
          const servicesArray = Object.values(data).map(service => service.name);
          setServices(servicesArray);
        } else {
          console.log("No services found in the database");
          setError("No services available");
        }
      } catch (error) {
        console.error("Error fetching services:", error);
        setError("Failed to load services");
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmissionStatus(null);

    // Basic validation
    if (!formData.firstName || !formData.secondName || !formData.email || !formData.phoneNumber || !formData.service || !formData.date) {
      setSubmissionStatus({ type: 'error', message: 'Please fill in all required fields' });
      return;
    }

    try {
      // Fetch existing bookings to determine the next key
      const bookingsResponse = await fetch('https://armour-pro-2a88a-default-rtdb.firebaseio.com/bookings.json');
      const bookingsData = await bookingsResponse.json();
      const bookingsCount = bookingsData ? Object.keys(bookingsData).length : 0;
      const nextKey = String(bookingsCount + 1).padStart(3, '0'); // e.g., 001, 002

      // Save booking with the sequential key
      const response = await fetch(`https://armour-pro-2a88a-default-rtdb.firebaseio.com/bookings/${nextKey}.json`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          createdAt: new Date().toISOString(),
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to save booking');
      }

      setSubmissionStatus({ type: 'success', message: 'Booking submitted successfully!' });
      // Reset form
      setFormData({
        firstName: '',
        secondName: '',
        email: '',
        phoneNumber: '',
        service: '',
        date: '',
        additionalNotes: '',
      });
    } catch (error) {
      console.error("Error saving booking:", error);
      setSubmissionStatus({ type: 'error', message: 'Failed to submit booking. Please try again.' });
    }
  };

  // Animation variants for the form fields
  const fieldVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
  };

  return (
    <div
      className="home-page"
      style={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        position: "relative",
      }}
    >
      <TopNavbar />
      <SecondNav />

      {/* Booking Section */}
      <Box
        sx={{
          minHeight: '100vh',
          backgroundImage: 'url(https://media.istockphoto.com/id/154945530/photo/convertible-going-through-car-wash.jpg?s=612x612&w=0&k=20&c=1jIwwRiFL_Et-qm0rv9TX3pguMeaX2Fjhy6pdi_eJ0o=)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          position: 'relative',
          zIndex: 1,
          '&::before': {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.65))",
            zIndex: -1,
          },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: 6,
          mt: 4,
        }}
      >
        {/* Hero Section */}
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: 'easeOut' }}
          >
            <Typography
              variant="h2"
              sx={{
                fontWeight: 'bold',
                color: '#fff',
                textShadow: '0 4px 8px rgba(0,0,0,0.5)',
                fontSize: { xs: '2.5rem', md: '4rem' },
                background: 'linear-gradient(45deg, #1E88E5, #42A5F5)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Book Your Service Now
            </Typography>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3, ease: 'easeOut' }}
          >
            <Typography
              variant="h6"
              sx={{
                color: '#fff',
                fontSize: { xs: '1.2rem', md: '1.5rem' },
                fontWeight: 300,
                mt: 2,
                letterSpacing: '0.5px',
              }}
            >
              Experience the Best in Automotive Care
            </Typography>
          </motion.div>
        </Box>

        {/* Booking Form */}
        <Container maxWidth="md">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={{
              hidden: { opacity: 0 },
              visible: { opacity: 1, transition: { staggerChildren: 0.2 } },
            }}
          >
            <Box
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)', // Glassmorphism effect
                backdropFilter: 'blur(10px)',
                borderRadius: 8,
                boxShadow: '0 8px 30px rgba(0,0,0,0.3)',
                p: { xs: 3, sm: 5 },
                border: '1px solid rgba(255, 255, 255, 0.2)',
                maxWidth: 'sm', // Narrower form width to allow centering
                mx: 'auto', // Center the form container horizontally
              }}
            >
              {submissionStatus && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <Alert severity={submissionStatus.type} sx={{ mb: 3 }}>
                    {submissionStatus.message}
                  </Alert>
                </motion.div>
              )}
              <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 3,
                  alignItems: 'center', // Center the form fields horizontally
                }}
              >
                {/* Row 1: First Name and Second Name */}
                <Box sx={{ width: '100%' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <motion.div variants={fieldVariants}>
                        <TextField
                          label="First Name"
                          variant="outlined"
                          fullWidth
                          required
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleInputChange}
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': { borderColor: '#1E88E5' },
                              '&:hover fieldset': { borderColor: '#42A5F5' },
                              '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
                              backgroundColor: 'rgba(255, 255, 255, 0.05)',
                            },
                            '& .MuiInputLabel-root': { color: '#fff' },
                            '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
                            '& .MuiOutlinedInput-input': { color: '#fff' },
                          }}
                        />
                      </motion.div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <motion.div variants={fieldVariants}>
                        <TextField
                          label="Second Name"
                          variant="outlined"
                          fullWidth
                          required
                          name="secondName"
                          value={formData.secondName}
                          onChange={handleInputChange}
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': { borderColor: '#1E88E5' },
                              '&:hover fieldset': { borderColor: '#42A5F5' },
                              '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
                              backgroundColor: 'rgba(255, 255, 255, 0.05)',
                            },
                            '& .MuiInputLabel-root': { color: '#fff' },
                            '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
                            '& .MuiOutlinedInput-input': { color: '#fff' },
                          }}
                        />
                      </motion.div>
                    </Grid>
                  </Grid>
                </Box>

                {/* Row 2: Email and Phone Number */}
                <Box sx={{ width: '100%' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <motion.div variants={fieldVariants}>
                        <TextField
                          label="Email"
                          variant="outlined"
                          fullWidth
                          required
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': { borderColor: '#1E88E5' },
                              '&:hover fieldset': { borderColor: '#42A5F5' },
                              '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
                              backgroundColor: 'rgba(255, 255, 255, 0.05)',
                            },
                            '& .MuiInputLabel-root': { color: '#fff' },
                            '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
                            '& .MuiOutlinedInput-input': { color: '#fff' },
                          }}
                        />
                      </motion.div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <motion.div variants={fieldVariants}>
                        <TextField
                          label="Phone Number"
                          variant="outlined"
                          fullWidth
                          required
                          type="tel"
                          name="phoneNumber"
                          value={formData.phoneNumber}
                          onChange={handleInputChange}
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': { borderColor: '#1E88E5' },
                              '&:hover fieldset': { borderColor: '#42A5F5' },
                              '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
                              backgroundColor: 'rgba(255, 255, 255, 0.05)',
                            },
                            '& .MuiInputLabel-root': { color: '#fff' },
                            '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
                            '& .MuiOutlinedInput-input': { color: '#fff' },
                          }}
                        />
                      </motion.div>
                    </Grid>
                  </Grid>
                </Box>

                {/* Row 3: Service and Preferred Date */}
                {/* <Box sx={{ width: '100%' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <motion.div variants={fieldVariants}>
                        <TextField
                          select
                          label="Service"
                          variant="outlined"
                          fullWidth
                          required
                          name="service"
                          value={formData.service}
                          onChange={handleInputChange}
                          disabled={loading || error}
                          sx={{
                            // maxWidth: '300px', // Fixed width for Service field
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': { borderColor: '#1E88E5' },
                              '&:hover fieldset': { borderColor: '#42A5F5' },
                              '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
                              backgroundColor: 'rgba(255, 255, 255, 0.05)',
                            },
                            '& .MuiInputLabel-root': { color: '#fff' },
                            '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
                            '& .MuiOutlinedInput-input': { color: '#fff' },
                            '& .MuiSelect-icon': { color: '#fff' },
                          }}
                        >
                          {loading ? (
                            <MenuItem value="" disabled>
                              Loading...
                            </MenuItem>
                          ) : error ? (
                            <MenuItem value="" disabled>
                              {error}
                            </MenuItem>
                          ) : services.length === 0 ? (
                            <MenuItem value="" disabled>
                              No services available
                            </MenuItem>
                          ) : (
                            services.map((service, index) => (
                              <MenuItem key={index} value={service}>
                                {service}
                              </MenuItem>
                            ))
                          )}
                        </TextField>
                      </motion.div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <motion.div variants={fieldVariants}>
                        <TextField
                          label="Preferred Date"
                          variant="outlined"
                          fullWidth
                          required
                          type="date"
                          name="date"
                          value={formData.date}
                          onChange={handleInputChange}
                          InputLabelProps={{ shrink: true }}
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': { borderColor: '#1E88E5' },
                              '&:hover fieldset': { borderColor: '#42A5F5' },
                              '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
                              backgroundColor: 'rgba(255, 255, 255, 0.05)',
                            },
                            '& .MuiInputLabel-root': { color: '#fff' },
                            '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
                            '& .MuiOutlinedInput-input': { color: '#fff' },
                          }}
                        />
                      </motion.div>
                    </Grid>
                  </Grid>
                </Box> */}

               <Grid container spacing={2}>
  {/* Service Field */}
  <Grid item xs={12} sm={6} sx={{ mr: { sm: 10 } }}>
    <motion.div variants={fieldVariants}>
      <TextField
        select
        label="Service"
        variant="outlined"
        fullWidth
        required
        name="service"
        value={formData.service}
        onChange={handleInputChange}
        disabled={loading || error}
        sx={{
          minWidth: '355px',
          '& .MuiOutlinedInput-root': {
            '& fieldset': { borderColor: '#1E88E5' },
            '&:hover fieldset': { borderColor: '#42A5F5' },
            '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            height: '56px',
          },
          '& .MuiInputLabel-root': { color: '#fff' },
          '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
          '& .MuiOutlinedInput-input': {
            color: '#fff',
            paddingTop: '18.5px',
            paddingBottom: '18.5px',
          },
          '& .MuiSelect-icon': { color: '#fff' },
        }}
      >
        {loading ? (
          <MenuItem value="" disabled>Loading...</MenuItem>
        ) : error ? (
          <MenuItem value="" disabled>{error}</MenuItem>
        ) : services.length === 0 ? (
          <MenuItem value="" disabled>No services available</MenuItem>
        ) : (
          services.map((service, index) => (
            <MenuItem key={index} value={service}>{service}</MenuItem>
          ))
        )}
      </TextField>
    </motion.div>
  </Grid>

  {/* Preferred Date Field */}
  <Grid item xs={12} sm={6} sx={{ ml: { sm: -3 } }}>
    <motion.div variants={fieldVariants}>
      <TextField
        label="Preferred Date"
        variant="outlined"
        fullWidth
        required
        type="date"
        name="date"
        value={formData.date}
        onChange={handleInputChange}
        InputLabelProps={{ shrink: true }}
        sx={{
          '& .MuiOutlinedInput-root': {
            '& fieldset': { borderColor: '#1E88E5' },
            '&:hover fieldset': { borderColor: '#42A5F5' },
            '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            height: '56px',
          },
          '& .MuiInputLabel-root': { color: '#fff' },
          '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
          '& .MuiOutlinedInput-input': { color: '#fff' },
        }}
      />
    </motion.div>
  </Grid>
</Grid>





                {/* Row 4: Additional Notes */}
                <Box sx={{ width: '100%' }}>
                  <motion.div variants={fieldVariants}>
                    <TextField
                      label="Additional Notes"
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={3}
                      name="additionalNotes"
                      value={formData.additionalNotes}
                      onChange={handleInputChange}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': { borderColor: '#1E88E5' },
                          '&:hover fieldset': { borderColor: '#42A5F5' },
                          '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
                          backgroundColor: 'rgba(255, 255, 255, 0.05)',
                        },
                        '& .MuiInputLabel-root': { color: '#fff' },
                        '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
                        '& .MuiOutlinedInput-input': { color: '#fff' },
                      }}
                    />
                  </motion.div>
                </Box>

                {/* Row 5: Book Now Button */}
                <Box sx={{ width: '100%' }}>
                  <motion.div
                    variants={fieldVariants}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        background: 'linear-gradient(45deg, #1E88E5, #42A5F5)', // Blue gradient
                        color: '#fff', // White text
                        fontWeight: '600',
                        borderRadius: 3,
                        padding: '12px 0',
                        boxShadow: '0 4px 10px rgba(30, 136, 229, 0.4)',
                        '&:hover': {
                          background: 'linear-gradient(45deg, #1565C0, #1E88E5)',
                          boxShadow: '0 6px 15px rgba(30, 136, 229, 0.6)',
                        },
                      }}
                      type="submit"
                      fullWidth
                    >
                      Book Now
                    </Button>
                  </motion.div>
                </Box>
              </Box>
            </Box>
          </motion.div>
        </Container>
      </Box>

      <ChatPopup />
      <Footer />
    </div>
  );
}

export default Booking;